import { render } from "./EditUserForm.vue?vue&type=template&id=03ccd385"
import script from "./EditUserForm.vue?vue&type=script&lang=js"
export * from "./EditUserForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "03ccd385"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03ccd385', script)) {
    api.reload('03ccd385', script)
  }
  
  module.hot.accept("./EditUserForm.vue?vue&type=template&id=03ccd385", () => {
    api.rerender('03ccd385', render)
  })

}

script.__file = "src/components/settings/EditUserForm.vue"

export default script